// The chat model picker's "preferred default" rule, in one place: a member who has not chosen a
// model gets Claude Opus 5.5 whenever the agent's catalogue offers it. The passerelle mirrors the
// Claude side of this (client/passerelle/model-default.ts) for runs that send no model.

/** Matches an Opus 5.5 id in any agent's catalogue (e.g. `claude-opus-5-5`, `anthropic/claude-opus-5-5`). */
const PREFERRED_MODEL_RE = /opus[-. ]?5[-. ]?5/i

export function isPreferredModel(id: string): boolean {
  return PREFERRED_MODEL_RE.test(id)
}

/**
 * The model to select for an agent: the member's saved choice if the catalogue still lists it,
 * else the catalogue's Opus 5.5 entry, else the first entry ('' for an empty catalogue).
 */
export function pickModel(list: readonly { id: string }[], saved: string | null): string {
  if (saved && list.some((m) => m.id === saved)) return saved
  return (list.find((m) => isPreferredModel(m.id)) ?? list[0])?.id ?? ''
}
